import { render, staticRenderFns } from "./Charter.vue?vue&type=template&id=42476002&scoped=true"
import script from "./Charter.vue?vue&type=script&lang=js"
export * from "./Charter.vue?vue&type=script&lang=js"
import style0 from "./Charter.vue?vue&type=style&index=0&id=42476002&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42476002",
  null
  
)

export default component.exports